import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, SectionHeader, Typography } from 'web-library';
import Link from "@mui/material/Link";
import { Theme as AugmentedTheme } from 'web-library/theme/interface';

import { makeStyles } from 'tss-react/mui';
import ReceiptDetails from '../../../../../components/ReceiptDetails';
import { AppealSimplePaymentDetail } from '../../../../../models/@candidate/candidateAppealResultSchema';

const useStyles = makeStyles()((theme) =>
({
  viewSummaryText: {
    fontWeight: 800,
    paddingLeft: theme.spacing(1),
  },
  sectionHeader: {
    marginBottom: theme.spacing(4),
  },
  receiptDetails: {
    marginTop: theme.spacing(3),
  },
}));

export interface TransactionDetailProps {
  fromCoordinator?: boolean;
  hideTitle?: boolean;
  transaction: AppealSimplePaymentDetail | undefined;
  toSummary: () => void;
}

const ReceiptDetail = ({
  fromCoordinator = false,
  hideTitle = false,
  transaction,
  toSummary,
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <>
      {!hideTitle && (
        <Grid container>
          <Grid xs={12}>
            <SectionHeader
              title={t('appeal->>AppealReceipt.PaymentSummary')}
              className={classes.sectionHeader}
            >
              <Link
                  id="link-viewFullSummary"
                  className={classes.viewSummaryText}
                  onClick={toSummary}
              >
                {t('appeal->>AppealReceipt.ViewFullSummary')}
              </Link>
            </SectionHeader>
          </Grid>
        </Grid>
      )}
      <Typography>{t('appeal->>AppealReceipt.AppealOutcomeStatement')}</Typography>
      <Box className={classes.receiptDetails}>
        <ReceiptDetails transaction={transaction} />
      </Box>
    </>
  );
};

export default ReceiptDetail;
